import { type AgentMessageFragmentPlan } from "@/hooks/use-stream-conversation";
import { type FC } from "react";
import { Heading1, Heading2 } from "@/components/podkit/typography/Headings";
import { Markdown } from "@/components/ai/chat/Markdown";
import { Button } from "@/components/flexkit/Button";
import { useSaveSessionPlan } from "@/hooks/use-session-plan";
import { useParams } from "react-router-dom";
export const FragmentPlan: FC<{
    fragment: AgentMessageFragmentPlan;
}> = ({ fragment }) => {
    // extracting from URL to avoid polluting non prototype-code with session ID by passing it all the way down to this fragment
    const { sessionId } = useParams();
    const { mutateAsync: savePlan } = useSaveSessionPlan(sessionId);

    const usePlan = () => {
        void savePlan(fragment.plan);
    };

    return (
        <div className="flex flex-col items-start gap-4 overflow-x-hidden rounded-xl border-0.5 border-border-base bg-surface-pure p-6">
            <Heading1 className="w-full min-w-0 truncate">{fragment.plan.title}</Heading1>
            <div className="flex flex-col gap-4">
                {fragment.plan.steps.map((step) => (
                    <div key={step.id}>
                        <Heading2 className="text-content-primary">{step.spec.title}</Heading2>
                        <Markdown content={step.spec.prompt} />
                    </div>
                ))}
            </div>
            <Button variant="primary" size="sm" onClick={usePlan}>
                Use plan
            </Button>
        </div>
    );
};
